<template>
  <div>
    <v-row no-gutters>
      <v-col md="7" sm="12" class="pa-0 ma-0 pr-md-1 mb-2">
        <v-card>
          <location-name-bulk-update-modal
              @savePayload="mountPayload"
          />
          <v-divider/>

          <div>
            <location-categories-modal
                @savePayload="mountPayload"
                @removePayload="removePayload"
                :bulkUpdate="true"
            />
            <location-code-modal
                @savePayload="mountPayload"
                @removePayload="removePayload"
                :bulkUpdate="true"
            />
            <location-address-modal
                @savePayload="mountPayload"
                @removePayload="removePayload"
                :bulkUpdate="true"
            />
            <location-description-modal
                @savePayload="mountPayload"
                @removePayload="removePayload"
                :bulkUpdate="true"
            />
            <location-phone-modal
                @savePayload="mountPayload"
                @removePayload="removePayload"
                :bulkUpdate="true"
            />
            <location-site-modal
                @savePayload="mountPayload"
                @removePayload="removePayload"
                :bulkUpdate="true"
            />
            <location-labels-modal
                @savePayload="mountPayload"
                @removePayload="removePayload"
                :bulkUpdate="true"
            />
            <location-schedule-modal
                @savePayload="mountPayload"
                @removePayload="removePayload"
                :bulkUpdate="true"
            />
            <location-special-schedule-modal
                @savePayload="mountPayload"
                @removePayload="removePayload"
                :bulkUpdate="true"
            />
            <location-more-schedule-modal
                v-for="(hourType, index) in moreHourTypes"
                :key="index"
                :title="hourType.localized_display_name"
                :hourType="hourType.hours_type_id"
                @savePayload="mountPayload"
                @removePayload="removePayload"
                :bulkUpdate="true"
            />
            <location-attributes-modal
                @savePayload="mountPayload"
                @removePayload="removePayload"
                :attrs="getAllAttributes()"
                :bulkUpdate="true"
            />
            <location-attribute-url-modal
                v-for="attr in get(bulkAttributes, 'url', {})"
                :key="attr.id"
                :title="attr.display_name"
                :attribute-id="attr.attribute_id"
                :value="get(attr, 'current_value.pivot.url_values[0].url')"
                @savePayload="mountPayload"
                @removePayload="removePayload"
                :bulkUpdate="true"
            />
          </div>

          <v-divider/>

          <v-card-actions>
            <v-row no-gutters class="lighten-5 pl-4 pr-4 pt-4">
              <v-col md="5" class="pr-2">
                <date-picker
                    outlined
                    dense
                    label="Agendar para"
                    clearable
                    hide-details
                    @change="val => this.schedule_start = val"
                />
              </v-col>
              <v-col md="3" class="pl-2">
                <v-text-field
                    outlined
                    dense
                    label="Horário de início"
                    clearable
                    @change="val => this.schedule_start_at = val"
                    type="time"
                ></v-text-field>
              </v-col>
              <v-col md="4" class="pl-2">
                <confirm-modal
                    outlined
                    width="600px"
                    :action="sendData"
                    action-text="Aplicar alterações"
                    title="Aplicar alterações"
                    description="Deseja mesmo aplicar as alterações?"
                />
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col md="5" sm="12" class="pa-0 ma-0 pl-md-1 mb-2">
        <v-card>
          <v-card-title>Informações Variáveis</v-card-title>
          <v-card-text>{{
              `Algumas informações podem ser dinâmicas para cada local. Basta colocar o nome da variável entre chaves duplas. Ex: "{\{store_code}\}"`
            }}
          </v-card-text>

          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">Nome da variável</th>
                <th class="text-left">Informação correspondente</th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(description, name) in variables"
                  :key="name"
              >
                <td>{{ name }}</td>
                <td>{{ description }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar.show" timeout="3000" :color="snackbar.color">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import {handleResponseError} from '@/api/handleError'
import {get} from 'lodash'
import {mapState} from 'vuex'
import {TYPE_UPDATE_LOCATION_ON_GMB} from '@/constants/tasks'
import LocationNameBulkUpdateModal from '@/views/Locations/Modals/LocationNameBulkUpdateModal'
import LocationPhoneModal from '@/views/Locations/Modals/LocationPhoneModal'
import LocationSiteModal from '@/views/Locations/Modals/LocationSiteModal'
import LocationDescriptionModal from '@/views/Locations/Modals/LocationDescriptionModal'
import LocationScheduleModal from '@/views/Locations/Modals/LocationScheduleModal'
import LocationSpecialScheduleModal from '@/views/Locations/Modals/LocationSpecialScheduleModal'
import LocationMoreScheduleModal from '@/views/Locations/Modals/LocationMoreScheduleModal'
import LocationLabelsModal from '@/views/Locations/Modals/LocationLabelsModal'
import LocationCodeModal from '@/views/Locations/Modals/LocationCodeModal'
import LocationAddressModal from '@/views/Locations/Modals/LocationAddressModal'
import LocationAttributesModal from '@/views/Locations/Modals/LocationAttributesModal'
import LocationAttributeUrlModal from '@/views/Locations/Modals/LocationAttributeUrlModal'
import LocationCategoriesModal from '@/views/Locations/Modals/LocationCategoriesModal'
import DatePicker from '@/components/DatePicker'
import ConfirmModal from '@/components/ConfirmModal'

export default {
  name: 'LocationInfoBulkUpdateTab',
  props: {
    ids: {
      required: true,
      type: Array,
    },
    account: {
      required: true,
      type: String,
    },
    allSelected: {
      required: true,
      type: Boolean,
    },
    filters: Object,
    total: Number,
  },
  computed: {
    ...mapState({
      location: (state) => state.locations.location,
      variables: (state) => state.locations.bulkVariables,
      bulkAttributes: (state) => state.locations.bulkAttributes,
      moreHourTypes: (state) => state.locations.moreHourTypes,
    }),
    get() {
      return get
    }
  },
  components: {
    LocationPhoneModal,
    LocationSiteModal,
    LocationDescriptionModal,
    LocationLabelsModal,
    LocationScheduleModal,
    LocationSpecialScheduleModal,
    LocationMoreScheduleModal,
    LocationNameBulkUpdateModal,
    LocationCodeModal,
    LocationAddressModal,
    LocationAttributesModal,
    LocationAttributeUrlModal,
    LocationCategoriesModal,
    DatePicker,
    ConfirmModal
  },
  created() {
    this.$store.dispatch('locations/getBulkVariables')
    this.$store.dispatch('locations/getMoreHourTypes')
  },
  mounted() {
    this.$store.dispatch('locations/getBulkAttributes', {
      allSelected: this.allSelected ? 1 : 0,
      account: this.account,
      ids: this.ids,
      total: this.total,
    })
  },
  data: () => ({
    loading: false,
    variablesData: null,
    dialog: false,
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
    payloadData: {},
    schedule_start: '',
    schedule_start_at: ''
  }),
  methods: {
    changeScheduleDate(data) {
      this.payloadData.schedule_start = data.schedule_start
      this.payloadData.schedule_start_at = data.schedule_start_at
    },
    sendData: async function () {
      try {
        let filters = this.filters
        filters.search = this.filters.search || ''
        const payload = {
          schedule_type: TYPE_UPDATE_LOCATION_ON_GMB,
          schedule_start: this.schedule_start,
          schedule_start_at: this.schedule_start_at,
          params: {
            allSelected: this.allSelected ? 1 : 0,
            account: this.account,
            ids: this.ids,
            total: this.total,
            filters
          },
          ...this.payloadData,
        }

        this.loading = true
        await this.$store
            .dispatch('locations/sendBulk', { payload })
            .then((res) => {
              this.loading = false
              this.showNotification('Alterações salvas!', 'green darken-2')
              if (get(res, 'data.tasks[0].id')) {
                this.$router.push(`/task/${get(res, 'data.tasks[0].id')}`)
              } else {
                this.showNotification('Nenhuma tarefa foi criada.', 'red darken-2')
              }
            })
            .catch((e) => {
              this.loading = false
              const message = handleResponseError(e, 'Ocorreu um erro ao enviar os dados.')
              this.showNotification(message, 'red darken-2')
            })
        this.loading = false
      } catch (e) {
        const message = handleResponseError(e, 'Ocorreu um erro ao enviar os dados.')
        this.showNotification(message, 'red darken-2')
      }
    },
    mountPayload(key, value) {
      this.payloadData[key] = value
    },
    removePayload(key) {
      delete this.payloadData[key]
    },
    showNotification(message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    getAllAttributes() {
      const all = get(this.bulkAttributes, 'all', {})
      const result = Array.isArray(all)
        ? {}
        : typeof all === 'object'
          ? all
          : {}
      return result
    }
  }
}
</script>

<style scoped>
.my-link {
  text-decoration: none;
}

.buttonSend {
  float: right;
  margin-top: 10px;
}

.my-link:hover {
  text-decoration: underline;
}

.card-info {
  margin-top: 12px;
}

@media screen and (min-width: 960px) {
  .card-info {
    margin-top: 0;
  }
}
</style>
